/**
 * Compares two array to see if they are identic
 * 
 * @param {Array} array1 the first array
 * @param {Array} array2 the second array
 * @returns boolean true if the two arrays are similar
 */
export function areArraysEqual(array1, array2) {
    return JSON.stringify(array1) === JSON.stringify(array2);
}